import { useCallback, useEffect, useRef } from "react"

export function useDebounced(callback, delay = 700) {
  const timeoutRef = useRef(null)
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  const cancel = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  const debouncedFn = useCallback(
    (...args) => {
      cancel()

      timeoutRef.current = setTimeout(() => {
        callbackRef.current(...args)
        timeoutRef.current = null
      }, delay)
    },
    [cancel, delay]
  )

  useEffect(() => {
    return () => cancel()
  }, [cancel])

  return [debouncedFn, cancel]
}